import { render, staticRenderFns } from "./empty-gem.vue?vue&type=template&id=263528ce&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports